exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search-container[data-v-03051432] {\n  margin-bottom: 20px;\n}\n.search-card .el-form[data-v-03051432] {\n  margin-bottom: 10px;\n}\n.search-actions[data-v-03051432] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  gap: 10px;\n  margin-top: 10px;\n}\n", ""]);

// exports
